import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#icon-LeadOpportunities_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4c.949 0 1.848.332 2.562.928A1 1 0 1 1 6.28 6.463a2 2 0 1 0-2.277 3.27l.145.076a1 1 0 0 1 .51 1.262l-.042.092-.056.098-.045.065-.014.016a1 1 0 0 1-.493.336c-.826.248-1.598.716-2.083 1.276l-.125.155a1 1 0 0 1-1.6-1.2c.425-.567.996-1.058 1.646-1.448A4 4 0 0 1 5 4m22 11c0-6.075-4.925-11-11-11S5 8.925 5 15s4.925 11 11 11c2.677 0 5.131-.956 7.039-2.547l5.254 5.254.094.083a1 1 0 0 0 1.32-1.497l-5.253-5.255A10.96 10.96 0 0 0 27 15m-16.769 6.908C11.48 20.113 13.645 19 16.001 19c2.354 0 4.52 1.113 5.767 2.91A8.96 8.96 0 0 1 16 24a8.96 8.96 0 0 1-5.769-2.092M16.001 6a9 9 0 0 0-7.172 14.44 8.8 8.8 0 0 1 3.75-2.794 5 5 0 1 1 6.841.002 8.76 8.76 0 0 1 3.751 2.79A9 9 0 0 0 16 6m-3 8A3 3 0 1 1 19 14a3 3 0 0 1-6 0m18-6a4 4 0 0 0-6.563-3.07 1 1 0 1 0 1.284 1.533 2 2 0 1 1 2.128 3.348l-.102.056a1 1 0 0 0-.297 1.412l.058.078.05.055.102.093a1 1 0 0 0 .33.172c.902.272 1.739.805 2.21 1.432a1 1 0 1 0 1.599-1.2c-.425-.567-.997-1.058-1.647-1.447A4 4 0 0 0 31 8"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-LeadOpportunities_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgIconLeadOpportunities = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLeadOpportunities);
export default Memo;
